export default __webpack_public_path__ + "static/media/logo.81d75165.png";